import {
  FiberManualRecord as FiberManualRecordIcon,
  InsertCommentRounded as InsertCommentRoundedIcon,
  MoreHoriz as MoreHorizIcon,
  PlayArrow as PlayArrowIcon,
  Public as PublicIcon,
} from '@mui/icons-material';
import { Avatar, Box, Card, IconButton, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect, useRef, useState } from 'react';
import { CommonHelper } from 'src/utils/commonHelper';
import Youtubelikedislike from '../../../../assets/youtube-like.svg';
import youtubeShare from '../../../../assets/youtube-share-whiteicon.svg';

const YoutubeShortsPreview = ({ data }) => {
  const theme = useTheme();
  const videoRef = useRef(null);
  const respwidth = useMediaQuery(theme.breakpoints.up('xl'));
  const [isShortsPlaying, setShortsPlaying] = useState(false);
  const [showControls, setShowControls] = useState(false);
  const ConnectedProfiles = data.connected_profile_details;

  useEffect(() => {
    return () => {
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    };
  }, []);

  const handlePlayButtonClick = () => {
    if (videoRef.current) {
      videoRef.current.play().catch((error) => {});
      setShowControls(true);
    }
  };

  const handleVideoPlay = () => {
    setShortsPlaying(true);
  };
  const handleVideoPause = () => {
    setShortsPlaying(false);
  };

  //Styled Componente
  const GradientOverlay = styled('div')({
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '48px',
    height: '48px',
  });

  const PlayButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '48px',
    height: '48px',
    backgroundColor: '#fff',
    borderRadius: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
  }));

  return (
    <>
      <Stack container justifyContent="center" alignItems="center">
        <Card sx={{ height: 460, width: 300, maxWidth: 500, minWidth: respwidth ? 300 : 200, borderRadius: '8px' }}>
          <video
            preload="auto"
            crossOrigin="anonymous"
            src={data.media_url}
            width="100%"
            height="100%"
            style={{
              objectFit: 'cover',
              position: 'absolute',
              borderRadius: '10px',
            }}
            ref={videoRef}
            controls={showControls}
            onPlay={handleVideoPlay}
            onPause={handleVideoPause}
          />
          {!isShortsPlaying && (
            <PlayButton onClick={handlePlayButtonClick}>
              <PlayArrowIcon sx={{ fontSize: 40 }} />
            </PlayButton>
          )}
          <GradientOverlay />
          <Box
            sx={{
              position: 'absolute',
              bottom: '18px',
              width: 'calc(100% - 62px)',
              display: 'flex',
              flexDirection: 'column',
              marginLeft: '18px',
              zIndex: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.7rem',
                marginBottom: '8px',
                color: '#fff',
              }}
            >
              <Avatar
                src={
                  ConnectedProfiles.connected_profile_image
                    ? ConnectedProfiles.connected_profile_image
                    : ConnectedProfiles.connected_profile_name || ConnectedProfiles.connected_profile_id
                }
                alt={
                  ConnectedProfiles.connected_profile_name
                    ? ConnectedProfiles.connected_profile_name
                    : ConnectedProfiles.connected_profile_id
                }
                sx={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  textAlign: 'center',
                  height: 35,
                  width: 35,
                  bgcolor: theme.palette.primary.main,
                }}
                style={{ color: 'white' }}
              />
              <Typography variant="body2">{data?.connected_profile_details?.connected_profile_name}</Typography>
              <FiberManualRecordIcon sx={{ fontSize: 5 }} />
              <PublicIcon sx={{ fontSize: 15, mr: 1 }} />
            </Box>
            <Typography
              style={{
                display: '-webkit-box',
                WebkitBoxOrient: 'vertical',
                WebkitLineClamp: 1,
                overflow: 'hidden',
                WebkitBoxDecorationBreak: 'clone',
                whiteSpace: 'pre-line',
                textOverflow: 'ellipsis',
                color: 'white',
              }}
            >
              {CommonHelper.ParseDescription(data.description)}
            </Typography>
          </Box>
          <Box
            sx={{
              position: 'absolute',
              bottom: '16px',
              right: '12px',
              display: 'flex',
              flexDirection: 'column',
              gap: '29px',
              alignItems: 'center',
            }}
          >
            <img
              src={Youtubelikedislike}
              style={{
                height: 'auto',
                width: '100%',
                maxWidth: '20px',
                maxHeight: '20px',
                marginRight: '1rem',
                color: 'white',
              }}
            />
            <img
              src={Youtubelikedislike}
              style={{
                height: 'auto',
                width: '100%',
                maxWidth: '20px',
                maxHeight: '20px',
                marginRight: '1rem',
                color: 'white',
                transform: 'rotate(180deg)',
              }}
            />
            <InsertCommentRoundedIcon sx={{ color: 'white', marginRight: '1rem' }} />
            <img
              src={youtubeShare}
              style={{
                height: 'auto',
                width: '100%',
                maxWidth: '20px',
                maxHeight: '20px',
                marginRight: '1rem',
                color: 'white',
              }}
            />
            <MoreHorizIcon sx={{ color: 'white', marginRight: '1rem' }} />
            <Box
              sx={{ width: '24px', height: '24px', marginTop: '-21px', borderRadius: '4.3px', maskSize: 'cover' }}
            ></Box>
          </Box>
        </Card>
      </Stack>
    </>
  );
};

export default YoutubeShortsPreview;
